import { render, staticRenderFns } from "./redact.vue?vue&type=template&id=22e076b6&scoped=true&"
import script from "./redact.vue?vue&type=script&lang=js&"
export * from "./redact.vue?vue&type=script&lang=js&"
import style0 from "./redact.vue?vue&type=style&index=0&id=22e076b6&lang=scss&scoped=true&"
import style1 from "./redact.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e076b6",
  null
  
)

export default component.exports